import React from 'react';
import { useTranslation } from 'react-i18next';

// Shown at the end of AI-generated reports (Research, Personnel). Reminds the
// reader that AI output can be wrong and that TrustFlow Research is information
// only — not investment advice.
export default function Disclaimer() {
  const { t } = useTranslation();
  return (
    <div style={s.wrap}>
      <p style={s.note}>
        ⚠️ <strong>{t('disclaimer.noteLabel')}:</strong> {t('disclaimer.noteText')}
      </p>
      <p style={s.disclaimer}>{t('disclaimer.legalText')}</p>
    </div>
  );
}

const s = {
  wrap: {
    margin: '28px auto 0',
    maxWidth: 900,
    background: 'var(--surface)',
    border: '1px solid var(--border)',
    borderRadius: 12,
    padding: '14px 18px',
  },
  note: { margin: '0 0 8px', fontSize: 12.5, lineHeight: 1.7, color: 'var(--text)' },
  disclaimer: { margin: 0, fontSize: 11.5, lineHeight: 1.7, color: 'var(--text-muted)', fontStyle: 'italic' },
};
